<template>
  <i :class="bem.b()" :style="style">
    <slot>
      <svg aria-hidden="true">
        <use :xlink:href="iconName" />
      </svg>
    </slot>
  </i>
</template>
<script lang="ts" setup>
import { computed, CSSProperties } from 'vue'

import { createNamespace, addUnit } from '@ll-plus/utils'
import { iconProps } from './icon'

// 1.defineOptions
defineOptions({
  name: 'LlIcon'
})

// 2.props
const props = defineProps(iconProps)

// 3.ref/const
// 图标在 iconfont 中的名字
const iconName = computed(() => {
  return `#${props.iconName}`
})
// 给图标加size和color
const style = computed<CSSProperties>(() => {
  if (!props.size && !props.color) {
    return {}
  }
  return {
    ...(props.size ? { 'font-size': addUnit(props.size) } : {}),
    ...(props.color ? { color: props.color } : {})
  }
})
const bem = createNamespace('icon')
</script>
